/* ---------------------------------------------------------------------------
   What an import must carry.

   A model is a CSiBridge export and the triangles CSiBridge drew, never a bridge
   the modeller rebuilds from parameters. So an export with no `Mesh` parts is
   refused: by the register before it mints a model for it
   (src/modeler/importModel.ts), and by the server on the upload
   (functions/api/modeler/source.ts).
   --------------------------------------------------------------------------- */

/** Whether any of an import's texts is a document with at least one mesh part. */
export function exportHasMesh(texts: readonly string[]): boolean {
  return texts.some((text) => {
    try {
      const mesh = (JSON.parse(text) as { Mesh?: { Parts?: unknown } } | null)?.Mesh;
      return Array.isArray(mesh?.Parts) && mesh.Parts.length > 0;
    } catch {
      return false;
    }
  });
}

/** Why an export with no mesh is refused, in one sentence. */
export const NO_MESH_REASON =
  'This export carries no mesh, and a model is not rebuilt from its parameters. Export it again from CSiBridge with Create Cloud Model.';
